export default {
  meta: {
    title: '商圈客流热力图PDF',
  },
};
